import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Paginator from "primevue/paginator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UPaginator',
    props: {
        rows: {
            type: Number,
            default: 30
        },
        totalRecords: {
            type: Number,
            default: 70
        }
    },
    emits: ["page"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Paginator), {
                rows: __props.rows,
                "total-records": __props.totalRecords,
                onPage: _cache[0] || (_cache[0] = e => _ctx.$emit('page', e))
            }, null, 8, ["rows", "total-records"]));
        };
    }
});
